<template>
    <div>
        <legend class="m-0 w-auto font-weight-bold">
            {{label}}
        </legend>
        <div v-if="fieldOptions.length">
            <toggle-button
                class="mb-0"
                :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                :sync="true"
                :labels="{ checked: 'Hide', unchecked: 'Show' }"
                :width="90"
                :height="20"
                :speed="200"
                v-model="showField"
            />
        </div>
        <div v-if="showField">
            <div class="mb-3 d-flex align-items-center">
                <div class="ml-3 custom-control custom-checkbox"
                     v-if="fieldOptions.length">
                    <input type="checkbox"
                           class="custom-control-input"
                           :id="fieldName + 'All'"
                           v-model="selectAll"
                           @change="selectAllOptions">
                    <label class="custom-control-label" :for="fieldName + 'All'">
                        Select all
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="loading">
                    <div>
                        <card-spinner></card-spinner>
                    </div>
                </div>
                <div v-if="fieldOptions.length && !loading"
                     class="col-md-4 checkbox"
                     v-for="option in fieldOptions"
                     :key="option.id">
                    <label class="checkbox-inline px-2">
                        <input v-model="currentSelection" type="checkbox"
                               :value="option.id"
                               @change="optionSelected">
                        <div v-if="displayOptionProperties.length">
                            <div v-for="property in displayOptionProperties">
                                <small><b>{{property}}</b>: {{option[property]}}&nbsp</small>
                            </div>
                        </div>
                        <small class="text-secondary"><em>(ID: {{option.id}})</em></small>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import isEqual from 'lodash';

    export default {
        props     : {
            label: {required: true},
            fieldName: {required: true},
            fieldOptions: {required: true},
            fieldSelection: {required: true},
            loading: {default: false},
            displayOptionProperties: {required:false}
        },
        data      : () => ({
            showField: true,
            selectAll: false,
            currentSelection: [],
        }),
        computed: {

        },
        watch     : {
            fieldSelection: {
                immediate: true,
                handler() {
                   this.currentSelection = this.fieldSelection;
                }
            }
        },
        methods: {
            selectAllOptions() {
                if (this.selectAll) {
                    this.currentSelection = this.fieldOptions.map((option) => option.id);
                    this.$emit('updateSelection', this.currentSelection);
                    return;
                }
                this.currentSelection = [];
                this.$emit('updateSelection', this.currentSelection);
            },

            optionSelected() {
                let optionIds = this.fieldOptions.map((option) => option.id);
                if (_.isEqual(_.sortBy(optionIds), _.sortBy(this.currentSelection))) {
                    this.selectAll = true;
                    this.$emit('updateSelection', this.currentSelection);
                    return;
                }
                this.selectAll = false;
                this.$emit('updateSelection', this.currentSelection);
            }
        }
    }
</script>
